import React from "react";
import "./styles/works.css";

const WORKS = [
	{ img: "./dubimark.png", title: "Dubimark", subtitle: "Full Stack Developer & Mobile App Dev", duration: "09/2025 – Present" },
	{ img: "./liali.png", title: "Liali Events", subtitle: "Sr Full Stack Developer & CRM Expert", duration: "03/2024 – 09/2025" },
	{ img: "./vm2.png", title: "VM Properties", subtitle: "Sr Full Stack Developer (Freelance)", duration: "" },
	{ img: "./amco.png", title: "Amco IT Systems", subtitle: "Full Stack Developer", duration: "03/2023 – 02/2024" },
	{ img: "./logoxi.png", title: "XI Creatives", subtitle: "Full Stack / Node.js Developer", duration: "01/2022 – 02/2023" },
	{ img: "./up.jpg", title: "Freelancer · Upwork & Fiverr", subtitle: "Full Stack / Mobile App Developer", duration: "2019 – Present" },
];

const Works = () => (
	<div className="works-body">
		{WORKS.map((w, i) => (
			<div className="work" key={i}>
				<img src={w.img} alt={w.title} className="work-image" />
				<div className="work-info">
					<div className="work-title">{w.title}</div>
					<div className="work-subtitle">{w.subtitle}</div>
				</div>
				{w.duration && <div className="work-duration">{w.duration}</div>}
			</div>
		))}
	</div>
);

export default Works;
